import React, { useContext, useMemo } from "react";

import { useTheme } from "styled-components";
import { ChartContext } from "../context";
import { getUserValueFromField } from "../../../helpers/cosmos-field-value-extractor";

import { useOrgChartStore } from "../../../stores/use-org-chart-store";
import CardWithDrop from "./droppable/CardWithDrop";
import ListWithDrop from "./droppable/ListWithDrop";
import { ChartCardView, ChartListView } from "@caelor/ui";
import { useOpticsStore } from "../../../stores/use-optics-store";
import { useStyleguideColors } from "../../../hooks/use-styleguide-colors";

export const ViewOptions = {
  CARD: "card",
  LIST: "list",
};

function ViewSelector({ isPreview, selectedView, componentProps }) {
  const { userRecords, fields, isCosmosInstalled, isMacrosuiteInstalled } =
    useContext(ChartContext);

  const { data } = useOrgChartStore((state) => ({
    data: state.data,
  }));

  const { styleguideSetup } = useOpticsStore((state) => ({
    styleguideSetup: state.styleguideSetup,
  }));

  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  const viewOptions = {
    borderRadius: data.config.cardBorderRadius,
    titleFieldId: data.config.titleFieldId,
    footerFieldId: data.config.footerFieldId,
    color:
      data.config?.lineColor?.light ||
      styleguideColors?.accent?.light ||
      "#4C9AFF",
  };

  const theme = useTheme();

  const Content = useMemo(() => {
    const AvailableComponents = {
      [ViewOptions.CARD]: ChartCardView,
      [ViewOptions.LIST]: ChartListView,
      [`droppable-${ViewOptions.CARD}`]: CardWithDrop,
      [`droppable-${ViewOptions.LIST}`]: ListWithDrop,
      [undefined]: () => <></>,
    };
    return AvailableComponents[
      `${isPreview ? "" : "droppable-"}${data.config.variant}`
    ];
  }, [data, isPreview]);

  const { node, userInfo, selectedUser, isLoading, handleOpeningUserProfile } =
    componentProps;

  const chartPreviewProps = {
    node,
    userInfo,
    selectedUser,
    getUserValueFromField,
    isLoading,
    additionalProps: {
      onItemClick: handleOpeningUserProfile,
      shouldCheckCosmosLicense: true,
      shouldCheckMacrosuiteLicense: true,
      isCosmosInstalled,
      isMacrosuiteInstalled,
      fields,
      userRecords,
      viewOptions,
    },
    darkTheme: {
      backgroundColor: theme.background,
      grayedBackgroundColor: theme.orgchart.grayedBackground,
      titleColor: theme.orgchart.name,
      descriptionColor: theme.orgchart.description,
      boxShadow: theme.orgchart.boxShadow,
      minusPlusColor: theme.orgchart.minusPlusColor,
    },
  };

  if (isPreview) {
    return <Content {...chartPreviewProps} />;
  }

  return <Content {...componentProps} />;
}

export default ViewSelector;
